import { useOutletContext } from "react-router-dom";
import type { AppOutletContext } from "./types/app.js";

export function useAppContext() {
  return useOutletContext<AppOutletContext>();
}
